module.exports = __webpack_public_path__ + "static/sofafun-f232aa11d66c48cab9238ef7258bdb7e.webp";